import { func } from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Subject } from 'rxjs';
import { Source } from '../../../constants/Source';
import { ILoadingError } from '../../hooks/useLoadingErrorCatcher/useLoadingErrorCatcher.types';
import { IMediaManagerSDKRequestOptions, MediaManagerSDKAnyItem, MediaManagerSDKFolder } from '../../media-manager-sdk';
import { IWithFolderPathInner } from '../withFolderPath/withFolderPath.types';
import { IWithMediaTypesInner } from '../withMediaTypes/withMediaTypes.types';

export interface ISaveScrollElementNodeForItemsLoader {
  saveScrollElementNodeForItemsLoader: (element: InfiniteScroll) => void;
}

export interface IWithItemsLoaderInner {
  items: MediaManagerSDKAnyItem[];
  nextPageItems: MediaManagerSDKAnyItem[];
  resetFilesStream: Subject<null>;

  isLoading: boolean;
  hasMoreItems: boolean;
  areNextFilesLoading: boolean;

  loadMoreItems: () => void;
  refreshFolder: () => void;
}

export interface IWithItemsLoaderOuter
  extends Pick<IWithMediaTypesInner, 'mediaType' | 'mediaTypes'>,
    Pick<IWithFolderPathInner, 'folderId' | 'currentFolder'> {
  source: Source;
  currentFolder: MediaManagerSDKFolder;
  isPathFolderValid: boolean;

  setLoadingError: (loadingError: ILoadingError) => void;
}

export type TItemsLoaderConfig = {
  foldersOnly?: boolean;
  loaderOptions?: IMediaManagerSDKRequestOptions;
};

export type TGetItemsLoaderConfig = ((props: any) => TItemsLoaderConfig) | TItemsLoaderConfig;

export const saveScrollElementNodeContextTypes = {
  saveScrollElementNodeForItemsLoader: func,
};
